// extracted by mini-css-extract-plugin
export default {"opponents":"Opponents_opponents__WBktV","name":"Opponents_name__vqmWl"};